import { SettingUrls } from 'constants/SettingsUrls';
import { PackageProviderName } from 'data/ppoints/constants';
import { ProviderSettingsSection } from 'data/ppoints/enums/ProviderSettingsSection';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export const providerUrl = (providerName: PackageProviderName | string, countryName: string) =>
    `${SettingUrls.shippingProviders}/${providerName}/${countryName}`;

export const providerSectionUrl = (
    providerName: PackageProviderName | string,
    countryName: string,
    section: ProviderSettingsSection
) => `${providerUrl(providerName, countryName)}/${section}`;

export const useProviderNavigation = () => {
    const navigate = useNavigate();

    const goToProvider = useCallback(
        (providerName: PackageProviderName | string, countryName: string) => {
            navigate(providerUrl(providerName, countryName));
        },
        [navigate]
    );

    // Opens one of the provider's settings sub-pages (e.g. Connection at `.../connect`).
    // This replaces the previous `?tab=` deep link: each section is now its own route.
    const goToProviderSection = useCallback(
        (providerName: PackageProviderName | string, countryName: string, section: ProviderSettingsSection) => {
            navigate(providerSectionUrl(providerName, countryName, section));
        },
        [navigate]
    );

    return { goToProvider, goToProviderSection };
};
